import React from "react";

const AppFooter: React.FC = () => (
  <footer className="mx-auto mt-auto w-full max-w-5xl px-4 pb-8 sm:px-6">
    <div className="border-t border-border pt-6 text-center text-sm text-muted">
      <nav className="mb-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" aria-label="Footer">
        <a href="/api_docs" className="text-muted no-underline hover:text-ink">
          API docs
        </a>
        <a href="/terms" className="text-muted no-underline hover:text-ink">
          Terms
        </a>
        <a href="/privacy" className="text-muted no-underline hover:text-ink">
          Privacy Policy
        </a>
        <a href="mailto:info@lightning-swap.com" className="text-muted no-underline hover:text-ink">
          Contact Us
        </a>
      </nav>
      <div>&copy; {new Date().getFullYear()} Lightning Swap</div>
    </div>
  </footer>
);

export default AppFooter;
